/** Minimum ms to show auth loading state */
export const MIN_AUTH_LOADING_MS = 1000;
